/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MinDueAmount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function MinDueAmount({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New/MinDueAmount",
  onChange
  
}) {
let reportFilterValuesMinAmountValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'filter_values.min_amount',
})
let reportFilterValuesMinAmountChangeData = fromData.useDataChange({ viewPath,
context: 'report',
path: 'filter_values.min_amount',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 required={true}
 flexGrow={0}
 type="number"
 marginTop={dtSpaceS}
 data="report.filter_values.min_amount"
 onChange={reportFilterValuesMinAmountChangeData}
 value={reportFilterValuesMinAmountValueData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Min due amount ($)"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}